import React from 'react';
import {Radio as AntRadio} from 'antd';
import './styles.less';
export default class Radio extends AntRadio {

    render(){
        return <AntRadio {...this.props} className={`hms-radio ${this.props.className || ''}`}>{this.props.children}</AntRadio>
    }
}
export const RadioGroup = AntRadio.Group;
export const RadioButton = AntRadio.Button;